import React, { useEffect } from 'react'
import { browserHistory } from 'react-router'
import useFeatureFlags from 'hooks/useFeatureFlags'
import PageWrapper from 'enrollment-platform/PageWrapper'

export default function CustomerGate({
  children,
}: {
  children: React.ReactNode
}) {
  const { flags } = useFeatureFlags()
  const flagEnabled = flags['ui.customer.new-experience']

  useEffect(() => {
    if (!flagEnabled) {
      browserHistory.replace('/')
    }
  }, [flagEnabled])

  if (!flagEnabled) {
    return null
  }

  return <PageWrapper>{children}</PageWrapper>
}
